module.exports = __webpack_public_path__ + "static/media/ritratto.2ad3c14d.jpg";